import { createAsyncThunk } from "@reduxjs/toolkit";

type ThunkApiConfig = {
    state: ReduxState;
    dispatch: ReduxDispatch;
    rejectValue: string;
};

export const createAppAsyncThunk = createAsyncThunk.withTypes<ThunkApiConfig>();
